import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

import fullDeal from "../queries/fragments/fullDeal"

const mutation = gql`
  mutation CreateCompanyBenefit($details: CompanyBenefitInput!) {
    createCompanyBenefit(details: $details) {
      ...fullDeal
    }
  }
  ${fullDeal}
`

export const createCompanyBenefitsKey = getQueryNames(mutation)[0]

export default mutation
